import { render, staticRenderFns } from "./Chambres.vue?vue&type=template&id=50f970d9&scoped=true"
import script from "./Chambres.vue?vue&type=script&lang=js"
export * from "./Chambres.vue?vue&type=script&lang=js"
import style0 from "./Chambres.vue?vue&type=style&index=0&id=50f970d9&prod&scoped=true&lang=scss"
import style1 from "./Chambres.vue?vue&type=style&index=1&id=50f970d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f970d9",
  null
  
)

export default component.exports